import type { DayButtonProps } from 'react-day-picker';
import { CalendarDayButton } from '@/components/ui/calendar';
import { cn } from '@/lib/utils';

export function PurchasePlanningCalendarDayButton({
  className,
  ...props
}: DayButtonProps) {
  return (
    <CalendarDayButton
      className={cn(
        'group-data-[focused=true]/day:relative!',
        'group-data-[focused=true]/day:z-auto!',
        'group-data-[focused=true]/day:border-0!',
        'group-data-[focused=true]/day:ring-0!',
        className,
      )}
      {...props}
    />
  );
}
